export default __webpack_public_path__ + "static/media/medicos_validacion_exitosa.03d6a573.svg";